import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/loader";
import { CategoryListAPIResponse } from "../../../interface/glassCategory.interface";
import { dynamicGlassCataloguesPDF, getSubCategoryList } from "../../../redux/homeSlice";
import { AppDispatch } from "../../../redux/store";
import { IsEmptyObject, IsStringNullEmptyOrUndefined } from "../../../utils/nullCheck";

function DownloadCatalogues() {
  const dispatch = useDispatch<AppDispatch>();

  const { loadingPDF } = useSelector(
    (state: any) => state.home
  );

  const { subCategoryData } = useSelector((state: any) => state.home);

  useEffect(() => {
    dispatch(getSubCategoryList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadCataloguePDF = async (subCategoryID: string) => {
    const result = await dispatch(dynamicGlassCataloguesPDF(subCategoryID)).unwrap();
    console.log("result:- ", result)
    if (result &&
      !IsEmptyObject(result) && result.statusCode === 200 && !IsEmptyObject(result.data) && !IsEmptyObject(result.data.data) &&
      !IsStringNullEmptyOrUndefined(result.data.data.AWSFilePath)
    ) {
      console.log("AWSFilePath :- ", result.data.data.AWSFilePath)
      // window.open(result.data.data.AWSFilePath, "_blank", "noopener,noreferrer");
      // let windowReference = window.open()
      // if(windowReference){
      //   windowReference.location.assign(result.data.data.AWSFilePath)
      // }
      // navigatePDFURL(result.data.data.AWSFilePath)
      return result.data.data.AWSFilePath
    }
  };

  const navigatePDFURL = (subCategoryID: string) => {
    let windowReference = window.open();
    downloadCataloguePDF(subCategoryID).then((pdfURL: string) => {

      if (windowReference) {
        windowReference.location.assign(pdfURL);
      }
    }).catch((error) => {
      console.error("Error downloading the catalogue:", error);
    });
  }

  return (
    <>
      <Loader isLoading={loadingPDF} />

      <section className="cataloguesDownloadWrapper py-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-3">
              <h2 className="titleMain">DOWNLOAD CATALOGUES</h2>
              <p className="txt-gray">
                View or download the catalogues that help you open the world of
                sophistication, and discover the perfect engineering to make
                your vision a reality.
              </p>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12 col-12 mobileSiteMap">
              <div className="title" style={{ textAlign: "center" }}>
                WALTZ
              </div>
              <ul className="siteMapHldr mb-4">
                <li>
                  {/* <Link to={`/waltz-pdf?title=slide`}>WALTZ SLIDE NXT</Link> */}
                  <a href="/assets/pdfs/SlideNXT.pdf" target="_blank">WALTZ SLIDE NXT</a>
                </li>
                <li>
                  {/* <Link to={`/waltz-pdf?title=glide`}>WALTZ GLIDE NXT</Link> */}
                  <a href="/assets/pdfs/GlideNXT.pdf" target="_blank">WALTZ GLIDE NXT</a>
                </li>
                <li>
                  {/* <Link to={`/waltz-pdf?title=swing`}>WALTZ SWING</Link> */}
                  <a href="/assets/pdfs/SwingNXT.pdf" target="_blank">WALTZ SWING</a>
                </li>
                <li>
                  {/* <Link to={`/waltz-pdf?title=close`}>WALTZ CLOSE NXT</Link> */}
                  <a href="/assets/pdfs/CloseNXT.pdf" target="_blank">WALTZ CLOSE NXT</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-12 mobileSiteMap">
              <div className="title" style={{ textAlign: "center" }}>
                GLASS
              </div>

              <ul className="siteMapHldr row">
                {/* {renderDynamicSubCategoriesWebsite(subCategoryData)} */}
                {/* {renderDynamicSubCategories(subCategoryData)} */}
                {
                  subCategoryData.map((item: CategoryListAPIResponse, index: number) => (
                    <li className="col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                      {item.categoryName}
                      <ul>
                        {item.subCategoryList?.map((child, childIndex) => (
                          <li key={childIndex}>
                            {/* <Link
                                to={`/catalogues-inner?subCategoryId=${child.subCategoryId
                                  }&subCategoryName=${encodeURIComponent(child.subCategoryName)}`}
                              // state={{
                              //   subCategoryId: child.subCategoryId,
                              //   subCategoryName: child.subCategoryName,
                              // }}
                              > */}
                            <p onClick={() => navigatePDFURL(child.subCategoryId)} style={{ fontSize: "0.75em", cursor: "pointer" }}>{child.subCategoryName}</p>
                            {/* </Link> */}
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))

                }
              </ul>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12 col-12 mobileSiteMap">
              <div className="title" style={{ textAlign: "center" }}>
                Wardrobe
              </div>
              <ul className="siteMapHldr">
                <li>
                  {/* <Link to={`/waltz-pdf?title=wardrobe`}>Wardrobe</Link> */}
                  <a href="/assets/pdfs/wardrobe-catalogue.pdf" target="_blank">Wardrobe</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default DownloadCatalogues;
